import React from 'react';

const ContentLists = () => (
  <div className="p-6">
    <h2 className="text-2xl font-bold mb-2">Content Lists</h2>
    <p className="text-gray-600">This is the Content Lists page.</p>
  </div>
);

export default ContentLists;
